var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"workflow__panel",class:_vm.positionClasses,style:({ pointerEvents: _vm.userSelectionActive ? 'none' : 'all' })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }